import { Container, Row, Col, Image, ProgressBar } from 'react-bootstrap';
import { FaJava, FaReact, FaJsSquare, FaDatabase, FaPython, FaNodeJs, FaGit, FaHtml5, FaDocker } from "react-icons/fa";
import { SiSpring, SiApachetomcat } from "react-icons/si";
import { DiJqueryLogo } from "react-icons/di";


const Portfolio = () => {

    const experiences = [
        {
            title: "공공기관프로젝트 참여",
            company: "에코누리시스템",
            role: "SENIOR WEB DEVELOPER",
            period: "2024.08 ~ 2024.11",
            tasks: [
                "산림청 - 목재이용실태조사 관련 통계 사업 구축"
            ],
        },
        {
            title: "한샘 이커머스 온라인 몰 개발 및 유지보수",
            company: "한샘",
            role: "SENIOR WEB DEVELOPER",
            period: "2015.09 ~ 2024.06",
            tasks: [
                "한샘닷컴 통합 개발",
                "홈아이디어 개발",
                "리하우스 개발",
                "한샘닷컴 개발",
                "반기별 한샘몰 사이트 개편",
                "한샘이사 개발",
                "상품 등록 개발",
                "주문 배송 개발",
                "입주박람회 개발",
                "OMS 연동으로 재입고 상품 기능 알람 발송 기능 개발",
                "설문/응모기능 및 데이터 피싱탐지 기능 신규 개발",
                "상담신청 구현 변경 및 기능 추가",
                "개인정보 보안화/접근자 필터링 및 ISMS 심사대응",
                "협력사 관리 및 개별 권한공지 대응",
                "개인정보 처리방침 관리 자동화 기능 신규 개발",
                "컴포넌트 별 모바일/PC 로딩속도 개선 및 최적화",
                "다회성 이벤트 관리 시스템 신규 개발",
                "첫 구매 고객 한정 상품 구매 시스템 신규개발 및 로그수집",
                "신규가입자 전용 쿠폰 발급자동화 기능 신규 개발",
                "정적 파일 버전관리 기능",
                "DB 데이터 문서화 및 통계 시각화",
                "개별 상품 SEO 최적화",
                "배치 스케줄러 개발",
            ],
        },
        {
            title: "아카이브 솔루션 구축",
            company: "AVECSOFT",
            role: "SENIOR WEB DEVELOPER",
            period: "2013.06 ~ 2015.02",
            tasks: [
                "산업인력공단 - 디지털 아카이브 플랫폼 구축/유지 보수",
                "국가기록원 - 디지털 아카이브 플랫폼 구축/유지 보수",
                "국립극장 - 공연 예술자료 통합관리시스템 구축",
                "(주)온디자인 - 체리시 협업 SNS",
                "(주)후지쯔 - 영월 조선 민화 박물관 파트원 프로젝트",
                "Avecsoft - 자사 디지털 아카이브 솔루션 개발",
                "육군과학화전투훈련단 - 디지털 아카이브 플랫폼 구축 사업",
                "국립무형유산원 - 디지털 아카이브 플랫폼 구축 사업",
            ],
        },
        {
            title: "디지털 컨텐츠 구축",
            company: "Ivary",
            role: "Junior Web Developer",
            period: "2011. 02 ~ 2013. 05",
            tasks: [
                "Ivary - IVARY Office 개발",
                "Ivary - IVARY R&D 매칭 사이트 개발",
                "Ivary - IVARY 한글/영문 사이트 개발",
                "(주)한국지오매틱스 - 한강하구생태지도 시스템구축",
                "Ivary - TeraImages 사이트 개발",
                "Ivary - 제한중량 초과차량운행허가 시스템 개발",
                "Ivary - IVARY CMS개발"
            ],
        },
        {
            title: "솔루션 개발 및 공공기관프로젝트 참여",
            company: "하이엘리더스투모로우",
            role: "Junior Web Developer",
            period: "2010. 06 ~ 2011. 01",
            tasks: [
                "(주)보건산업진흥원 - e-R&D 관리시스템 구축",
                "기술사회 - GLE 구축 사업"
            ],
        },
        {
            title: "솔루션 개발 및 공공기관프로젝트 참여",
            company: "거버넌스",
            role: "Junior Web Developer",
            period: "2008. 06 ~ 2010. 03",
            tasks: [
                "산림청 대국민 포털사이트 숲에On 개발",
                "2009 국가 통합사업 신품종 통합 DB구축",
                "산림 종자 품목 DB 구축 사업",
                "항공관리본부 관리 사이트 개편"
            ],
        },
        {
            title: "솔루션 개발 및 공공기관프로젝트 참여",
            company: "지엠솔루션",
            role: "Junior Web Developer",
            period: "2007. 10 ~ 2008. 06",
            tasks: [
                "본사 그룹웨어 Laf/J FrameWork 개편",
                "(주)LG-CNS - LGE조달협업 시스템통합구축(GERP)",
                "(주)LG-CNS - 본사 그룹웨어 Laf/J FrameWork 개편",
                "(주)LGHILOGISTICS - LG전자 설치배송 일원화 사업"
            ],
        },
        {
            title: "솔루션 개발 및 유지보수",
            company: "대명이엔지",
            role: "Junior Web Developer",
            period: "2004. 06 ~ 2007. 02",
            tasks: [
                "(주)대명ENG, (주)Avaco, (주)Avatec - 공작 기기별 절삭 시간 및 임율 관리 개발/ 사내 ERP 관리 / 전산관리"
            ],
        },
        {
            title: "솔루션 개발 및 유지보수",
            company: "신안상사",
            role: "Junior Web Developer",
            period: "2003. 05 ~ 2004. 06",
            tasks: [
                "신안상사 - 사내 전산 솔루션 구축 및 관리"
            ],
        }
    ];

    const skillsIcon = [
        { name: "Java", icon: <FaJava size={40} color="#007396" />, level: 100 },
        { name: "Spring", icon: <SiSpring size={40} color="#6DB33F" />, level: 100 },
        { name: "Git", icon: <FaGit size={40} color="#61DAFB" />, level: 60 },
        { name: "React", icon: <FaReact size={40} color="#61DAFB" />, level: 60 },
        { name: "JavaScript", icon: <FaJsSquare size={40} color="#F7DF1E" />, level: 85 },
        { name: "Jquery", icon: <DiJqueryLogo size={40} color="#F7DF1E" />, level: 100 },
        { name: "Node.js", icon: <FaNodeJs size={40} color="#339933" />, level: 70 },
        { name: "Python", icon: <FaPython size={40} color="#3776AB" />, level: 70 },
        { name: "SQL / DB", icon: <FaDatabase size={40} color="#4479A1" />, level: 100 },
        { name: "HTML5", icon: <FaHtml5 size={40} color="#4479A1" />, level: 100 },
        { name: "Docker", icon: <FaDocker size={40} color="#4479A1" />, level: 50 },
        { name: "Tomcat", icon: <SiApachetomcat size={40} color="#4479A1" />, level: 100 },
    ];

    const skillsDesc = [
        {
            title: "BACK-END",
            tasks: [
                "Java, JSP, NodeJS, Express, Python", "Spring Boot, Spring MVC, Spring Batch", "JPA, SQL, Mybatis", "Junit4/5", "Gradle, Maven"
            ]
        },
        {
            title: "Dev-Ops",
            tasks: [
                "Gitea, SVN", "Oracle, MSSQL, MySQL, MariaDB, PostgreSQL, MongoDB", "Apache, Nginx, Tomcat", "Scouter", "Windows IIS, Linux Centos", "Docker"
            ]
        },
        {
            title: "Front-end",
            tasks: [
                "ES5, ES6", "Npm, DhtmlX, Webpack", "Apache, Nginx, Tomcat", "Jquery, Ejs, Jstl", "React"
            ]
        },
        {
            title: "IDE",
            tasks: [
                "Eclipse, IntelliJ, STS, Visual Studio Code, Pycharm"
            ]
        }
    ];

    const competence = [
        {
            title: "레거시 시스템 리팩토링/리엔지니어링",
            tasks: [
                "전체 시스템 (Spring to Springboot)마이그레이션", "java 1.6 to 1.9 업데이트 대응", "점진적 ES5 to ES6 업데이트로 가독성 및 유지관리성 증대"
            ]
        },
        {
            title: "대용량 데이터 처리 및 성능 개선",
            tasks: [
                "MSSQL SlowQuery 부분 튜닝", "멤버십 API 연동", "Batch 개발 및 운영", "API / Batch 개발 및 운영", "일 트래픽 10만건의 포털 메인페이지 개발 및 관리", "메일 발송 시스템 구현", "대용량 Batch 시스템 구현", "Pinpoint/Scouter 성능 테스트 및 버그 모니터링"
            ]
        },
        {
            title: "로컬 인프라 운영 관리",
            tasks: [
                "[DEV] 로컬 SVN server, GIT server(Gitea) 등 로컬 개발 테스트 환경 구성"
            ]
        },
        {
            title: "견고한 데이터 구조 및 애플리케이션 설계",
            tasks: [
                "ORM/JPA로 효율적 DB연동", "SQL injection, XSS 처리 및 시큐어코딩으로 보안강화", "linux/tomcat server 오류 자동 로깅 관리"
            ]
        },
        {
            title: "댓글관리 서비스",
            tasks: [
                "인가된 사용자 실시간 영상 스트리밍 서비스", "댓글관리 외부모듈 연동", "악성 댓글 및 스팸게시글 블라인드 처리 자동화"
            ]
        }
    ]

    return (
        <div>
            <Container className="profile-container mt-1">
                <Image src="/frog.png" className="profile-img text-center" roundedCircle fluid style={{ width: '30%' }} />
                <h1 className="name">
                    <span className="kor-name">임승혁</span>{" "}
                    <span className="eng-name">SEUNG HYUK LIM</span>
                </h1>
                <h3 className="brand">WAJOK</h3>
                <p className="location">
                    SEOUL, KOREA{" "}
                    <a href="mailto:zzang246@gmail.com" className="email">
                        zzang246@gmail.com
                    </a>
                </p>

                <p className="description">
                    Java & Spring 기반의 20년차 서버 백엔드 개발자입니다.
                </p>
                <p className="description">
                    Framework를 이용한 시스템 개발 및 유지보수가 가능합니다. (SI/SM)
                </p>
                <p className="description">
                    환경에 따라 프론트엔드/백엔드를 융통성있게 스위칭합니다.
                </p>
                <p className="description">
                    JSP/JSTL, Mustache, Thymleaf 등을 이용하여 view page를 빠르고 안정적으로 구현 가능합니다.
                </p>
                <p className="description">
                    또한, React 및 Node.js / Express 를 이용한 간단한 대시보드 구성도 가능하고
                </p>
                <p className="description">
                    Python 과 Telegram API를 연동한 대화형 봇 개발이 가능하며 현재 서비스 중입니다.
                </p>
                <p className="bot-links">
                    <a href="https://t.me/wavis_bot" target="_blank" rel="noreferrer">와비스봇 바로가기</a><br /><br />
                    <a href="https://t.me/wavision_bot" target="_blank" rel="noreferrer">와비전봇 바로가기</a><br /><br />
                </p>
                <hr />
                <h2 className="section-title">SKILLS</h2>
                <Row>
                    {skillsIcon.map((skill, index) => (
                        <Col key={index} xs={6} md={4} lg={3} className="text-center mb-4">
                            {skill.icon}
                            <h5 className="mt-2">{skill.name}</h5>
                            <ProgressBar now={skill.level} label={`${skill.level}%`} className="mt-2" />
                        </Col>
                    ))}
                </Row>
                {
                    skillsDesc.map((skill, index) => {
                        return (
                            <div key={index} className="experience-item">
                                <h4 className="skill-title">{skill.title}</h4>
                                <ul className="task-list">
                                    {skill.tasks.map((task, idx) => (
                                        <li key={idx}>{task}</li>
                                    ))}
                                </ul>
                            </div>
                        )
                    })
                }
                <hr />
                <h2 className="section-title">EXPERIENCE</h2>
                {experiences.map((exp, index) => (
                    <div key={index} className="experience-item">
                        <h4 className="exp-title">{exp.title}</h4>
                        <h5 className="company-name">{exp.company}</h5>
                        <p className="role">{exp.role}</p>
                        <p className="period">{exp.period}</p>
                        <ul className="task-list">
                            {exp.tasks.map((task, idx) => (
                                <li key={idx}>{task}</li>
                            ))}
                        </ul>
                    </div>
                ))}
                <hr />
                <h2 className="section-title">COMPETENCE</h2>
                {
                    competence.map((com, index) => {
                        return (
                            <div key={index} className="experience-item">
                                <h4 className="skill-title">{com.title}</h4>
                                <ul className="task-list">
                                    {com.tasks.map((task, idx) => (
                                        <li key={idx}>{task}</li>
                                    ))}
                                </ul>
                            </div>
                        )
                    })
                }
                <hr />
                <h2 className="section-title">INTERESTS</h2>
                <p>성실함, 책임감, 협업, 조화로움, 이너피이스</p>
                <p>보람있는 행동, 그에 따른 충분한 자기만족</p>
                <p>냥이와 전기먹는 녀석이 주는 행복 지향</p>
                <p>원하는 복지 : 안정적, 미래지향적, 좋은사람들, 저녁이 있는 삶, 그리고 맛있는 점심</p>
            </Container>

        </div>
    )
};

export { Portfolio };